export const verifyGoogleToken = async (token) => {
    const response = await fetch("api/auth/",
        {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({token: token})
        });
    return await response.json();
}

const googleUserTokenKey = "GoogleUserToken";

export const storeUserToken = (token) => {
    localStorage.setItem(googleUserTokenKey, token);
}

export const getUserToken = () => {
    return localStorage.getItem(googleUserTokenKey);
}

export const removeUserToken = () => {
    localStorage.removeItem(googleUserTokenKey);
}